<template>
  <el-container class="PayForm">
    <el-main class="p-0">
      <el-form
        ref="form"
        label-width="80px"
        class="form-label-90"
        :model="data"
        :rules="rules"
        inline
      >
        <el-row>
          <el-col :span="6">
            <el-form-item label="결제일" prop="pay_date">
              <ADatePicker v-model="data.pay_date" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="결제방법" prop="pay_way_flag">
              <ASelector
                labelField="label"
                valueField="value"
                :items="pay_way_flag_options"
                v-model="data.pay_way_flag_temp"
                @change="handleChangePayWayFlag"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="결제액" prop="price">
              <ANumberInput v-model="data.price" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="할인액" prop="discount_price">
              <ANumberInput v-model="data.discount_price" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="비고" prop="desc" class="block">
              <el-input v-model="data.desc" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-main>
    <el-footer>
      <el-button
        type="primary"
        v-shortkey="['f4']"
        :disabled="!has_grant_write"
        :loading="load_button"
        @shortkey.native="handleClickRegister"
        @click="handleClickRegister"
        >{{ is_new ? "등록(F4)" : "수정 (F4)" }}</el-button
      >
      <el-button
        type="danger"
        v-if="!is_new"
        :disabled="!has_grant_write"
        :loading="load_button"
        @click="clickDel"
        >삭제</el-button
      >
      <el-button class="right" @click="closeDialog"
        >{{ $t("button.close") }} (Esc)</el-button
      >
    </el-footer>
  </el-container>
</template>
<script>
import { form } from "@/common/mixins/form";
import { account_form } from "@/common/mixins/account_form";

export default {
  name: "InvoiceForm",
  mixins: [form, account_form],
  data() {
    return {
      sum: 0,
      form_data: undefined,
      rules: {
        pay_date: [{ required: true, message: "결제일을 선택해 주세요." }],
        price: [{ required: true, message: "결제액을 입력해 주세요." }],
      },
      asset_way_flag_options: [
        { value: 1, label: "현금 결제" },
        { value: 2, label: "어음 결제" },
        { value: 3, label: "카드 결제" },
        // {value: 4, label: '상계 처리'},
      ],
      working: false,
      load_button: false,
    };
  },
  props: {
    customer: {
      type: Object,
      required: true,
    },
    data: {
      type: Object,
      default: function() {
        return {
          id: null,
          pay_way_flag: "1",
          pay_way_flag_temp: "1",
          pay_date: this.util.getDateString(),
          price: 0,
          discount_price: 0,
        };
      },
    },
    has_grant_write: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    is_new: function() {
      return this.data.id < 1;
    },
    pay_way_flag_options: function() {
      // deep copy
      let collect_list = JSON.parse(
        JSON.stringify(this.system.options.pay_way_flag)
      );
      // '통장' item 삭제
      collect_list.splice(1, 1);
      return this.convert_bankbook_options(collect_list, 1);
    },
  },
  methods: {
    handleClickRegister() {
      if (!this.has_grant_write) {
        return;
      }
      if (this.working) {
        return;
      }
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        this.doRegister();
      });
    },
    /** 데이터 값 정리 */
    organizeData() {
      let param = Object.assign({}, this.data);
      param.customer_id = this.customer.id;
      param.customer_name = this.customer.name;
      param.price = param.price === "" ? null : param.price;
      param.discount_price =
        param.discount_price === "" ? null : param.discount_price;
      return param;
    },
    doRegister() {
      const data = this.organizeData();
      this.working = true;
      this.load_button = true;
      if (this.is_new) {
        this.api.createPay(data).then((res) => {
          this.load_button = false;
          this.working = false;
          if (res.error !== this.system.noError) {
            this.util.notify_response_error(this, "결제", res);
          } else {
            this.completed("create", "등록되었습니다.");
          }
        });
      } else {
        this.api.updatePay(data).then((res) => {
          this.load_button = false;
          this.working = false;
          if (res.error !== this.system.noError) {
            this.util.notify_response_error(this, "결제", res);
          } else {
            this.completed("update", "수정되었습니다.");
          }
        });
      }
    },
    clickDel() {
      this.util.confirm_delete(this, "결제 정보", this.doDelete);
    },
    doDelete() {
      const data = this.organizeData();
      this.load_button = true;
      this.api.deletePay(data).then((res) => {
        this.load_button = false;
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, "결제", res);
        } else {
          this.completed("delete", "삭제되었습니다.");
        }
      });
    },
    handleChangePayWayFlag() {
      this.onChangePayWayFlag(this.data);
    },
    completed(action, message) {
      const options = this.util.get_notify_options("s", "결제", message);
      this.$emit("completed", action, options);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/_variables.scss";

.el-dialog__body .el-form div.el-input.form-input-mid {
  width: 641px;
}
</style>
